import { styled, Button } from "@mui/material";

export const ReferenceBooksButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h3Underlined,
  color: theme.palette.custom.grey.dark,
  display: "flex",
  alignItems: "center",
  alignSelf: "flex-end",
}));
